// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.671387L21 8.54639V20.0002H22V22.0002H13V20.0002H14V10.0002H10V20.0002H11V22.0002H2V20.0002H3V8.54639L12 0.671387ZM5.00079 20.0002H7.99921L8 10.0002H5L5.00079 20.0002ZM19 10.0002H16V20.0002H19L19 10.0002Z"}}]};

const DamFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-filled',
    ref,
    icon: element,
  },
));

DamFilledIcon.displayName = 'DamFilledIcon';

export default DamFilledIcon;
